var catNav = document.getElementById('press-cat-nav');

if (catNav) {
  var catTitle = document.getElementById('category-header-title'),
    catLogo = document.getElementById('category-header-logo'),
    catName = document.getElementById('category-header-name'),
    catDropdown = document.getElementById('tax-category__dropdown--toggle'),
    catMenu = document.getElementById('tax-category__nav--menu'),
    catCaret = document.getElementById('tax-category__dropdown--caret'),
    promoBar = document.getElementById('promo-notification'),
    stickyTop = catNav.offsetTop;
    
  window.addEventListener(
    'scroll',
    function (e) {
      if (window.innerWidth >= 980) {
        if (window.pageYOffset >= stickyTop + (promoBar ? promoBar.offsetHeight : 0)) {
          catNav.classList.add('sticky-header');
          catTitle.classList.add('active');
          catLogo.classList.add('active');
          catName.classList.add('active');
        } else {
          catNav.classList.remove('sticky-header');
          catTitle.classList.remove('active');
          catLogo.classList.remove('active');
          catName.classList.remove('active');
        }
      }
    },
    false
  );

  //Category Dropdown
  catDropdown.addEventListener('click', function (e) {
    e.preventDefault();
    catMenu.classList.toggle('tax-category__dropdown--dd-toggle');
    catCaret.classList.toggle('active');
  });

  //Link Click WebTracker Event
  var catLinks = catNav.querySelectorAll('a');
  for (var i = 0; i < catLinks.length; i++) {
    catLinks[i].addEventListener('click', function (e) {
      WebEventTracker.logEvent(EDS.webEvents, 'ClickedOnPressNav', {
        action: this.getAttribute('title'),
      });
    });
  }

  //Assign primary-category class for press pages
  if (document.body.classList.contains('single-press')) {
    var catPrimaryCat = catNav.querySelector('li.menu-item-primary-category'),
      catMenuParent = catNav.querySelector('li.current-menu-parent.active');

    if (!catPrimaryCat && catMenuParent) {
      catMenuParent.classList.add('menu-item-primary-category');
    }
  }
}